import { render, staticRenderFns } from "./goToPath.vue?vue&type=template&id=2a80406a&lang=pug&"
import script from "./goToPath.vue?vue&type=script&lang=js&"
export * from "./goToPath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports